import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ColumnSizes } from 'wflow-cdk';

export const PEPPOL_COLUMN_SIZES = new InjectionToken<PeppolColumnSizes>(
  'PEPPOL_COLUMN_SIZES',
);

export interface PeppolColumnSizes {
  get$(): Observable<ColumnSizes | undefined>;

  set(sizes: ColumnSizes): void;
}
